<template>
  <div
    class="rounded-2xl border border-gray-200 bg-gray-100/70 p-2 shadow-sm dark:border-stone-800 dark:bg-stone-950/70 sm:p-3"
  >
    <slot/>
  </div>
</template>
